<template>
  <v-row justify="center">
    <template v-if="!initialLoader">

      <v-app-bar v-if="isMobileDevice" height="55" :color="instance.account.color_background" :dark="isDark" prominent>
        <v-app-bar-nav-icon @click.stop="drawer=!drawer"></v-app-bar-nav-icon>
      </v-app-bar>

      <v-navigation-drawer v-if="isMobileDevice || instance.hosted_page_layout === 'vertical'" class="pa-6" v-model="drawer" :dark="isDark" :color="instance.account.color_background" width="280px"
        :absolute="isMobileDevice"
        :temporary="isMobileDevice"
        :app="!isMobileDevice"
        :clipped="!isMobileDevice"
        :floating="!isMobileDevice"
        :permanent="!isMobileDevice"
        >
        <v-sheet class="mx-2 mt-2 overflow-hidden" width="100" light rounded outlined>
          <v-responsive class="align-center" :aspect-ratio="1/1">
            <v-sheet class="px-1" color="white" width="100">
              <v-img :src="instance.account.logo" width="100%" />
            </v-sheet>
          </v-responsive>
        </v-sheet>
        <v-list class="mt-16" dense rounded>
          <v-list-item class="px-2" v-for="mi in instance.menu_items" :key="mi.label" :href="mi.url" target="_blank" link>{{mi.label}}</v-list-item>
        </v-list>
        <template v-slot:append>
          <v-list dense rounded>
            <v-list-item class="px-2 body-2" v-if="instance.terms_of_service_url" :href="instance.terms_of_service_url" target="_blank" link>Términos de uso</v-list-item>
            <v-list-item class="px-2 body-2" v-if="instance.privacy_policy_url" :href="instance.privacy_policy_url" target="_blank" link>Política de privacidad</v-list-item>
          </v-list>
          <piriod-sign-variant class="px-2" align="center" :dark="isDark" />
        </template>
      </v-navigation-drawer>

      <v-app-bar v-if="!isMobileDevice && instance.hosted_page_layout === 'horizontal'" :color="instance.color_background" :dark="isDark" app elevate-on-scroll>
        <v-sheet class="overflow-hidden mt-14" width="100" light rounded outlined>
          <v-responsive class="align-center" :aspect-ratio="1/1">
            <v-sheet class="px-1" color="white" width="100">
              <v-img :src="instance.account.logo" width="100%" />
            </v-sheet>
          </v-responsive>
        </v-sheet>
        <v-spacer />
        <v-btn class="ml-8" v-for="mi in instance.menu_items" :key="mi.label" :href="mi.url" target="_blank" text link>{{mi.label}}</v-btn>
      </v-app-bar>

    </template>
    <!-- widget -->
    <v-col cols="12" style="max-width:900px;">
      <div id="piriod-widget"></div>
    </v-col>
    <!-- end widget -->
    <v-col cols="6" class="text-center" v-if="instance.hosted_page_layout === 'horizontal'">
      <v-btn class="ml-4" v-if="instance.terms_of_service_url" :href="instance.terms_of_service_url" text>Términos de uso</v-btn>
      <v-btn class="ml-4" v-if="instance.privacy_policy_url" :href="instance.privacy_policy_url" text>Política de privacidad</v-btn>
      <piriod-sign-variant :dark="false" justify="center" />
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import tinycolor from 'tinycolor2'

import GenericViewMixin from '@/mixins/GenericViewMixin'
import PiriodSignVariant from '@/components/PiriodSignVariant'

export default {
  name: 'hosted-payment-link',
  components: {
    PiriodSignVariant
  },
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    drawer: false,
    initialLoader: false
  }),
  computed: {
    ...mapState({
      instance: state => cloneDeep(state.hosted.linksDetail)
    }),
    isMobileDevice () {
      return this.$vuetify.breakpoint.width <= 600
    },
    isDark () {
      if (!this.instance.account.color_background) {
        return false
      }
      const tc = tinycolor(this.instance.account.color_background)
      if (tc) {
        return tc.isDark()
      }
      return false
    }
  },
  mounted () {
    window.piriodSettings = {
      service: 'paymentLinks',
      linkId: this.$route.params.publishableKey
    }

    this.installPiriodWidget()
  },
  created () {
    this.initialLoader = true

    this.$store.dispatch('hosted/RETRIEVE', {
      resource: 'publishable/payment_links/links',
      detail: 'hosted',
      id: this.$route.params.publishableKey
    })
    .catch((error) => {
      if (error.response.status === 404) {
        this.$router.push({ name: 'PageExpired' })
      }
    })
    .finally(() => {
      setTimeout(() => {
        this.initialLoader = false
      }, 500)
    })
  },
  methods: {
    installPiriodWidget () {
      const s = document.createElement('script')

      s.src = this.$JS_BASE + '/embed/piriod-embed.umd.min.js'
      s.async = true
      s.type = 'text/javascript'

      const x = document.getElementsByTagName('script')[0]

      x.parentNode.insertBefore(s, x)
    }
  }
}
</script>
<style>
  .v-toolbar__content {
    margin: 0 auto !important;
    max-width: 860px !important;
  }
</style>